<span>
  <p-inputNumber
    [formControl]="formControl"
    [formlyAttributes]="field"
    (onInput)="props.onInput?.(field, $event)"
    (onBlur)="props.onBlur?.(field, $event)"
    (onFocus)="props.onFocus?.(field, $event)"
    (onKeyDown)="props.onKeyDown?.(field, $event)"
    (onClear)="props.onClear?.(field)"
    [allowEmpty]="props.allowEmpty ?? true"
    [autofocus]="props.autofocus ?? false"
    [buttonLayout]="props.buttonLayout ?? 'stacked'"
    [currency]="props.currency"
    [currencyDisplay]="props.currencyDisplay"
    [decrementButtonClass]="props.decrementButtonClass"
    [decrementButtonIcon]="props.decrementButtonIcon"
    [disabled]="props.disabled"
    [format]="props.format ?? true"
    [id]="id"
    [incrementButtonClass]="props.incrementButtonClass"
    [incrementButtonIcon]="props.incrementButtonIcon"
    [inputId]="props.inputId"
    [inputStyle]="props.inputStyle"
    [inputStyleClass]="props.inputStyleClass"
    [max]="props.max"
    [maxlength]="props.maxlength"
    [maxFractionDigits]="props.maxFractionDigits"
    [min]="props.min"
    [minFractionDigits]="props.minFractionDigits"
    [mode]="props.mode ?? 'decimal'"
    [placeholder]="props.placeholder"
    [prefix]="props.prefix"
    [readonly]="props.readonly ?? false"
    [required]="props.required ?? false"
    [showButtons]="props.showButtons ?? false"
    [showClear]="props.showClear ?? false"
    [size]="props.size"
    [step]="props.step ?? 1"
    [suffix]="props.suffix"
    [tabindex]="props.tabindex"
    [useGrouping]="props.useGrouping ?? true"
    [variant]="props.variant ?? 'outlined'"
    [name]="props.name"
    [autocomplete]="props.autocomplete"
    [ariaLabel]="props.ariaLabel"
    [ariaLabelledBy]="props.ariaLabelledBy"
    [ariaRequired]="props.ariaRequired ?? false"
  ></p-inputNumber>
</span>
